import SoundGUI from 'core/GUI/SoundGUI'
import SignalMediator from 'logic/sound/SignalMediator'
import SoundCore from 'logic/sound/SoundCore'
import { signal } from 'services/SignalsService'
import { StoreageService } from 'services/StoreageService'
import { sounds } from 'settings/custom/sounds'

export default class SoundManager {
  constructor() {
    this.core = new SoundCore()
    this.mediator = new SignalMediator()
    this.gui = new SoundGUI()

    this._parse()
    this.createSignal()
  }

  createSignal(){
    signal.once('SOUND:load', this.onInit.bind(this))
    signal.once('BUTTON:sound', this.onSound.bind(this))
    signal.once('SOUND:load', this.onLoad.bind(this))
  }

  onInit(){
    this.gui.init()
  }

  onSound(bool) {
    this.core.init()
    signal.on('TOGGLE:sound', (value) => this.core.mute(value))
    signal.on('VISIBILITY', (value) => this.core.mute(value && StoreageService.get('sound')))

    signal.dispatch('TOGGLE:sound', !!parseInt(bool))
  }

  onLoad(){
    const self = this

    Object.entries(sounds).forEach(([name, commands]) => {
      commands.forEach((comm) => signal.on(name, attachCommand(comm)))
    })

    function attachCommand(command) {
      return function () {
        self.core[command.action](command)
      }
    }
  }

  _parse() {
    const commands =  ['play', 'stop', 'pause', 'resume']
    Object.values(sounds).forEach((actions) => actions.forEach(process))

    function process(rule) {
      const action = commands.find((command) => rule[command])
      rule.action = action
      rule.name = rule[action]
      rule.fade = (rule.fade || 0) * 1000
      if (action == 'play') {
        rule.volume = rule.volume || 1
        rule.loop = rule.loop || false
      }
      delete rule[action]
    }
  }
}
